import { Component, Input, OnInit, SimpleChanges } from "@angular/core";
import { SOChannel, TypeIds } from "src/app/inventory/sales-order/constants/constants";
import { UtilityService } from "src/app/inventory/sales-order/utils/utility.service";
import { ImportserialService } from "src/app/modules/shared/services/importserial.service";

@Component({
    selector: "app-products-tax-split-view",
    templateUrl: "./products-tax-split-view.component.html",
    styleUrls: ["./products-tax-split-view.component.scss"],
})
export class ProductsTaxSplitViewComponent implements OnInit {
    @Input() products;
    @Input() isStateMatched;
    @Input() channel;
    @Input({ required: true}) savedCurrencyExchangeRate;
    @Input({ required: true}) savedCurrencyUnit;

    taxBasedProductsList = [];
    taxBasedProductsCols = [];
    taxGroupProductsList = [];
    taxPropertyMap = {
        [SOChannel.INVOICING]: "invoiceProductSubTax",
        [SOChannel.SALES_ORDER]: "salesOrderProductSubTax",
        [SOChannel.ESTIMATES]: "estimateProductSubTax",
        [SOChannel.BILL_ORDER]: "billOrderProductSubTax",
        [SOChannel.ITEM_RECEIPT]: "receivedPOProductSubTax",
        [SOChannel.PURCHASE_ORDER]: "purchaseOrderProductSubTax",
        [SOChannel.VENDOR_CREDIT]: "vendorCreditProductSubTax",
    };
    bundletaxPropertyMap = {
        [SOChannel.INVOICING]: "invoiceBundleDetailSubTax",
        [SOChannel.SALES_ORDER]: "salesOrderBundleDetailSubTax",
        [SOChannel.ESTIMATES]: "estimateBundleDetailSubTax",
    };
    // fraction digits
    fractionDigits: number = 0;

    // currency
    baseCurrency: any;
    orgCurrency = [];

    constructor(
        private utilityService: UtilityService,
        private importService: ImportserialService,
    ) {}

    ngOnInit(): void {
        this.getFractionDigits();
        this.getBaseCurrency();
    }
    getFractionDigits() {
        this.importService.getDecimalValue().subscribe({
            next: (value) => {
                if (value) {
                    this.fractionDigits = value;
                }
            },
            error: (error) => {},
        });
    }
    getBaseCurrency() {
        this.importService
            .getOrgCurrency()
            .subscribe((value) => {
                if (value) {
                    this.baseCurrency = value.find((cr) => cr.isBaseCurrency);
                    this.orgCurrency = value;
                }
            });
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.products && changes.products.currentValue) {
            this.products = changes.products.currentValue;
            this.prepareTaxBasedProductsList(this.products);
        }
    }

    /**
     * createTaxBasedProductsList is preparing tax based products list
     * Products applied tax will be splitted based on subcode tax
     * this split view should be visible only for India
     */
    prepareTaxBasedProductsList(pList: any[]) {
        const productsList = [];
        this.taxBasedProductsList = [];
        this.taxBasedProductsCols = [];
        this.taxGroupProductsList = [];

        pList?.forEach((item) => {
            if (item?.typeId != TypeIds.BundleTypeId) {
                productsList.push(item);
            } else {
                if (this.channel == SOChannel.INVOICING && item?.typeId == TypeIds.BundleTypeId && item?.invoiceBundleDetail?.length > 0) {
                    productsList.push(...item.invoiceBundleDetail);
                } else if (this.channel == SOChannel.SALES_ORDER && item?.typeId == TypeIds.BundleTypeId && item?.salesOrderBundleDetail?.length > 0) {
                    productsList.push(...item.salesOrderBundleDetail);
                } else if (this.channel == SOChannel.ESTIMATES && item?.typeId == TypeIds.BundleTypeId && item?.estimateBundleDetail?.length > 0) {
                    productsList.push(...item.estimateBundleDetail);
                }
            }
        });

        let taxSet = this.prepareTax(productsList);
        const subTaxProperty = this.taxPropertyMap[this.channel];
        const bundleSubTaxProperty = this.bundletaxPropertyMap[this.channel];
        const obj = {};
        taxSet?.forEach((tax) => {
            obj[String(tax)] = [];
            productsList?.forEach((product) => {
                let subTax = subTaxProperty ? product?.[subTaxProperty]?.find((sTax) => sTax.taxId == tax) : null;
                let bundleSubTax = bundleSubTaxProperty ? product?.[bundleSubTaxProperty]?.find((sTax) => sTax.taxId == tax) : null;
                if (subTax) {
                    let data = {};
                    data["itemNo"] = product?.itemNo || "";
                    data["hsnsac"] = product?.hsnsac || "";
                    data["taxPerc"] = subTax?.taxRate || 0;
                    data["taxAmount"] = subTax?.taxAmount || 0;
                    if (this.isStateMatched) {
                        data["CGST"] = subTax?.taxAmount ? Number(subTax?.taxAmount) / 2 : 0;
                        data["SGST"] = subTax?.taxAmount ? Number(subTax?.taxAmount) / 2 : 0;
                    } else {
                        data["IGST"] = subTax?.taxAmount || 0;
                    }
                    obj[String(tax)]?.push(data);
                }
                if (bundleSubTax) {
                    let data = {};
                    data["itemNo"] = product?.itemNo || "";
                    data["hsnsac"] = product?.hsnsac || "";
                    data["taxPerc"] = bundleSubTax?.taxRate || 0;
                    data["taxAmount"] = bundleSubTax?.taxAmount || 0;
                    if (this.isStateMatched) {
                        data["CGST"] = bundleSubTax?.taxAmount ? Number(bundleSubTax?.taxAmount) / 2 : 0;
                        data["SGST"] = bundleSubTax?.taxAmount ? Number(bundleSubTax?.taxAmount) / 2 : 0;
                    } else {
                        data["IGST"] = bundleSubTax?.taxAmount || 0;
                    }
                    obj[String(tax)]?.push(data);
                }
            });
        });
        this.prepareCols();

        for (let key in obj) {
            const d = {};
            let data = obj[key];
            if (data && data.length > 0) {
                let keys = Object.keys(data[0]);
                let obj = {};
                keys?.forEach((key) => {
                    if (key == "itemNo") {
                        obj[key] = data?.map((p) => p[key]).join(",");
                    }else if (key == "hsnsac") {
                        obj[key] = data?.map((p) => p[key]).filter((value) => value !== "").join(",");
                    }else if (key == "taxPerc") {
                        obj[key] = data[0]?.taxPerc || 0;
                    } else {
                        let value = 0;
                        data?.forEach((d) => {
                            value += Number(d[key]);
                        });
                        obj[key] = value;
                    }
                });
                this.taxBasedProductsList.push(obj);
            }
        }
    }

    prepareTax(productsList) {
        let taxSet = new Set();
        const subTaxProperty = this.taxPropertyMap[this.channel];
        if (subTaxProperty) {
            productsList?.forEach((product) => {
                product?.[subTaxProperty]?.forEach((tax) => {
                    if (tax?.taxAmount > 0 && tax?.taxRate > 0 && tax?.taxId) {
                        taxSet.add(tax.taxId);
                    }
                });
            });
        }
        const bundleSubTaxProperty = this.bundletaxPropertyMap[this.channel];
        if (bundleSubTaxProperty) {
            productsList?.forEach((product) => {
                product?.[bundleSubTaxProperty]?.forEach((tax) => {
                    if (tax?.taxAmount > 0 && tax?.taxRate > 0 && tax?.taxId) {
                        taxSet.add(tax.taxId);
                    }
                });
            });
        }
        return taxSet;
    }

    prepareCols() {
        if (this.isStateMatched) {
            this.taxBasedProductsCols = [
                { id: 1, header: "Item No", field: "itemNo" },
                { id: 2, header: "HSN Codes", field: "hsnsac" },
                { id: 3, header: "Tax (%)", field: "taxPerc" },
                { id: 4, header: "Taxable Amount", field: "taxAmount" },
                { id: 5, header: "CGST", field: "CGST" },
                { id: 6, header: "SGST", field: "SGST" },
            ];
        } else {
            this.taxBasedProductsCols = [
                { id: 1, header: "Item No", field: "itemNo" },
                { id: 2, header: "HSN Codes", field: "hsnsac" },
                { id: 3, header: "Tax (%)", field: "taxPerc" },
                { id: 4, header: "Taxable Amount", field: "taxAmount" },
                { id: 5, header: "IGST", field: "IGST" },
            ];
        }
    }
}
